import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Chapters from "./components/Chapters";
import Synopsis from "./components/Synopsis";
import Characters from "./components/Characters";
import Catalog from "./components/Catalog";
import Guide from "./components/Guide";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Chapters />
        <Synopsis />
        <Characters />
        <Catalog />
        <Guide />
        <FAQ />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}